import { render, staticRenderFns } from "./AuthPortal.vue?vue&type=template&id=6afeb808&"
import script from "./AuthPortal.vue?vue&type=script&lang=js&"
export * from "./AuthPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports